export default "__VITE_ASSET__534f548e__"